$(document).ready(function () {

  $('.m-search-form--clear').click(function() {
    $('.search_wrapper .form-field--input').val(''); 
    // $('.m-search-popup__result').hide();
    $('.desktop_search_wrapper predictive-search').removeAttr("open");
  });
  
  $(".logo_flex").slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: "linear",
    slidesToShow: 6,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  });
  $(".customer_flex").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5607 4.93934C13.9749 4.35355 13.0251 4.35355 12.4393 4.93934L3.43934 13.9393C2.85355 14.5251 2.85355 15.4749 3.43934 16.0607L12.4393 25.0607C13.0251 25.6464 13.9749 25.6464 14.5607 25.0607C15.1464 24.4749 15.1464 23.5251 14.5607 22.9393L8.12132 16.5L25.5 16.5C26.3284 16.5 27 15.8284 27 15C27 14.1716 26.3284 13.5 25.5 13.5H8.12132L14.5607 7.06066C15.1464 6.47487 15.1464 5.52513 14.5607 4.93934Z" fill="white"/></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.4393 4.93934C16.0251 4.35355 16.9749 4.35355 17.5607 4.93934L26.5607 13.9393C27.1465 14.5251 27.1465 15.4749 26.5607 16.0607L17.5607 25.0607C16.9749 25.6464 16.0251 25.6464 15.4393 25.0607C14.8536 24.4749 14.8536 23.5251 15.4393 22.9393L21.8787 16.5L4.5 16.5C3.67157 16.5 3 15.8284 3 15C3 14.1716 3.67157 13.5 4.5 13.5H21.8787L15.4393 7.06066C14.8536 6.47487 14.8536 5.52513 15.4393 4.93934Z" fill="white"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      { breakpoint: 576, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });
  $(".tab-contain div").hide();
  $(".tab-contain div:first").show().addClass("show_tab");
  $(".tab-nav li:first").addClass("active");
  $(".tab-nav a").on("click", function (event) {
    event.preventDefault();
    $(".tab-nav li").removeClass("active");
    $(this).parent().addClass("active");
    $(".tab-contain div").hide();
    $($(this).attr("href")).show().addClass("show_tab");
  });
  $(".tab-contain2 div").hide();
  $(".tab-contain2 div:first").show().addClass("show_active");
  $(".tab-nav li:first").addClass("active");
  $(".tab-nav2 a").on("click", function (event) {
    event.preventDefault();
    $(".tab-nav2 li").removeClass("active");
    $(this).parent().addClass("active");
    $(".tab-contain2 div").hide();
    $($(this).attr("href")).show().addClass("show_active");
  });
  $(".faq_heading_col").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).siblings(".faq_desc").slideUp();
      $(this).removeClass("active");
    } else {
      $(".faq_desc").slideUp();
      $(".faq_heading_col").removeClass("active");
      $(this).siblings(".faq_desc").slideToggle();
      $(this).toggleClass("active");
    }
  });
  let searchInput = document.querySelector(".search_input_drawer");
  searchInput.addEventListener("keyup", search);
  let titles = document.querySelectorAll(".search_bottom_col ul li a ");
  let searchTerm = "";
  let tit = "";
  function search(e) {
    searchTerm = e.target.value.toLowerCase();
    titles.forEach((title) => {
      tit = title.textContent.toLowerCase();
      tit.includes(searchTerm)
        ? (title.style.display = "block")
        : (title.style.display = "none");
    });
  }
 
  $(".product_list_col").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    arrows: true,
    slidesToScroll: 1,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5607 5.43934C13.9749 4.85355 13.0251 4.85355 12.4393 5.43934L3.43934 14.4393C2.85355 15.0251 2.85355 15.9749 3.43934 16.5607L12.4393 25.5607C13.0251 26.1464 13.9749 26.1464 14.5607 25.5607C15.1464 24.9749 15.1464 24.0251 14.5607 23.4393L8.12132 17L25.5 17C26.3284 17 27 16.3284 27 15.5C27 14.6716 26.3284 14 25.5 14H8.12132L14.5607 7.56066C15.1464 6.97487 15.1464 6.02513 14.5607 5.43934Z" fill="#FF0000"/></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.4393 5.43934C16.0251 4.85355 16.9749 4.85355 17.5607 5.43934L26.5607 14.4393C27.1465 15.0251 27.1465 15.9749 26.5607 16.5607L17.5607 25.5607C16.9749 26.1464 16.0251 26.1464 15.4393 25.5607C14.8536 24.9749 14.8536 24.0251 15.4393 23.4393L21.8787 17L4.5 17C3.67157 17 3 16.3284 3 15.5C3 14.6716 3.67157 14 4.5 14H21.8787L15.4393 7.56066C14.8536 6.97487 14.8536 6.02513 15.4393 5.43934Z" fill="#FF0000"/></svg></button>',
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });

  $(".m-tab-header").click(function () {
    $(".tabify_product_card_slider").slick("refresh");
  });
  $(".m-select-custom--option").click(function () {
    $(".tabify_product_card_slider").slick("refresh");
  });
  $(".m-menu-mobile li").click(function () {
    $(".m-megamenu-mobile").removeClass("active-menu-items");
    $(this).find(".m-megamenu-mobile").addClass("active-menu-items");
  });
  $(".prodcut_read_more_btn a").click(function () {
    $(".read_more_btn").slideToggle();
  });
  $(".coupon_copy_code a").on("click", function () {
    var $this = $(this);
    var value = $this.attr("data-value");
    var $temp = $("<textarea>");
    $("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();
    var $copiedMessage = $('<span class="copied-message">Copied</span>');
    $this.after($copiedMessage);
    $copiedMessage.css({
      position: "absolute",
      top: $this.position().top - $copiedMessage.outerHeight() - 5,
      left: $this.position().left,
      color: "#f00",
      background: "white",
      border: "1px solid #f00",
      padding: "5px",
      "border-radius": "5px",
    });
    setTimeout(function () {
      $copiedMessage.remove();
    }, 1500);
  });
  $(".page-link").on("click", function (event) {
    event.preventDefault();
    var url = $(this).attr("href");
    $("html, body").animate(
      { scrollTop: $(".collection-list").offset().top },
      600,
      function () {
        window.location.href = url;
      }
    );
  });
  
  $('.weight-toggle input[type="checkbox"]').on("change", function () {
    var selectedUnit = $(this).val();
    $(".m-product-option--content .main__product-weight").each(function () {
      if($('.weight-toggle input[type="checkbox"]').is(':checked')){ 
        var lb_Value = $(this).attr("data-value-lb");
        var shortText = jQuery.trim(lb_Value).substring(0, 4) + " lb";
        $(this).find(".m-product-option--node__label").text(shortText);
        // alert("it's checked");
      }else{
        var kg_Value = $(this).attr("data-value-kg");
        $(this).find(".m-product-option--node__label").text(kg_Value);
      };
     
    });
  });


  $(".hero_banner_block").slick({
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    adaptiveHeight: true,
    centerPadding: "0px",
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5607 4.93934C13.9749 4.35355 13.0251 4.35355 12.4393 4.93934L3.43934 13.9393C2.85355 14.5251 2.85355 15.4749 3.43934 16.0607L12.4393 25.0607C13.0251 25.6464 13.9749 25.6464 14.5607 25.0607C15.1464 24.4749 15.1464 23.5251 14.5607 22.9393L8.12132 16.5L25.5 16.5C26.3284 16.5 27 15.8284 27 15C27 14.1716 26.3284 13.5 25.5 13.5H8.12132L14.5607 7.06066C15.1464 6.47487 15.1464 5.52513 14.5607 4.93934Z" fill="white"/></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.4393 4.93934C16.0251 4.35355 16.9749 4.35355 17.5607 4.93934L26.5607 13.9393C27.1465 14.5251 27.1465 15.4749 26.5607 16.0607L17.5607 25.0607C16.9749 25.6464 16.0251 25.6464 15.4393 25.0607C14.8536 24.4749 14.8536 23.5251 15.4393 22.9393L21.8787 16.5L4.5 16.5C3.67157 16.5 3 15.8284 3 15C3 14.1716 3.67157 13.5 4.5 13.5H21.8787L15.4393 7.06066C14.8536 6.47487 14.8536 5.52513 15.4393 4.93934Z" fill="white"/></svg></button>',
  });
});

$(document).ready(function () {
  $(".tabify_product_card_slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: "100px",
    arrows: true,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5607 5.43934C13.9749 4.85355 13.0251 4.85355 12.4393 5.43934L3.43934 14.4393C2.85355 15.0251 2.85355 15.9749 3.43934 16.5607L12.4393 25.5607C13.0251 26.1464 13.9749 26.1464 14.5607 25.5607C15.1464 24.9749 15.1464 24.0251 14.5607 23.4393L8.12132 17L25.5 17C26.3284 17 27 16.3284 27 15.5C27 14.6716 26.3284 14 25.5 14H8.12132L14.5607 7.56066C15.1464 6.97487 15.1464 6.02513 14.5607 5.43934Z" fill="#FF0000"/></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.4393 5.43934C16.0251 4.85355 16.9749 4.85355 17.5607 5.43934L26.5607 14.4393C27.1465 15.0251 27.1465 15.9749 26.5607 16.5607L17.5607 25.5607C16.9749 26.1464 16.0251 26.1464 15.4393 25.5607C14.8536 24.9749 14.8536 24.0251 15.4393 23.4393L21.8787 17L4.5 17C3.67157 17 3 16.3284 3 15.5C3 14.6716 3.67157 14 4.5 14H21.8787L15.4393 7.56066C14.8536 6.97487 14.8536 6.02513 15.4393 5.43934Z" fill="#FF0000"/></svg></button>',
    onInit: function () {
      equalizeHeights();
    },
    onReInit: function () {
      equalizeHeights();
    },
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1,  centerPadding: "60px" } },
    ],
  });

  $(".tabify_product_card_slider").on("init", function (event, slick) {
    equalizeHeights();
  });

  // Function to equalize heights
  function equalizeHeights() {
    var maxHeight = 0;
    $(
      ".tabify_product_card_slider.slick-initialized .m-product-card, .tabify_product_card_slider.slick-initialized .feature-col "
    ).each(function () {
      var itemHeight = $(this).outerHeight();
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });
    $(
      ".tabify_product_card_slider.slick-initialized .m-product-card, .tabify_product_card_slider.slick-initialized .feature-col "
    ).css("height", maxHeight + "px");
  }

  $(window).on("load", function () {
    equalizeHeights();
  });

  $(document).ready(function () {
    equalizeHeights();
  });

  // Equalize heights on window resize
  $(window).on("resize", function () {
    equalizeHeights();
  });

$('.m-tab-header').click(function(){
    equalizeHeights();
})
});






